import React from 'react';
import EventCard from '../../shared/EventCard/EventCard';

const UpcomingList = ({ events }) => {
    if (!events || events.length === 0) return null;

    return (
        <>
            <div className="ch-ev-list__more-header">
                <div>
                    <h3 className="ch-ev-list__more-title">Future Events</h3>
                </div>
            </div>
            <div className="agenda-card-list">
                {events.map((ev) => <EventCard key={ev.id} event={ev} href={ev.event_url} />)}
            </div>
        </>
    );
};

export default UpcomingList;
